// extracted by mini-css-extract-plugin
module.exports = {"field":"Checkbox_field__ZkYRf","Checkbox":"Checkbox_Checkbox__CsgFD","errorMessage":"Checkbox_errorMessage__kWeKI"};